import { render, staticRenderFns } from "./TxHeader.vue?vue&type=template&id=564ce9c0&scoped=true&"
import script from "./TxHeader.vue?vue&type=script&lang=ts&"
export * from "./TxHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TxHeader.vue?vue&type=style&index=0&id=564ce9c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ce9c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VTooltip})
